import { render, staticRenderFns } from "./ProductDimensionsWidth.vue?vue&type=template&id=26f4e37c&"
import script from "./ProductDimensionsWidth.vue?vue&type=script&lang=ts&"
export * from "./ProductDimensionsWidth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports